import { render, staticRenderFns } from "./KaufschutzProductForm.vue?vue&type=template&id=1936d7ea&"
import script from "./KaufschutzProductForm.vue?vue&type=script&lang=js&"
export * from "./KaufschutzProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports